module.exports = __webpack_public_path__ + "static/gallery_kerry_3-f68d17b7a9c9182ccbb238843b80ee82.jpg";